export default __webpack_public_path__ + "static/media/nz_owned.dd6ee51d.svg";